import React from 'react';
import { ReviewOfSystem } from '../types/consultation.types';
import SectionNumberBadge from './SectionNumberBadge';

const SYSTEM_LABELS: Record<string, string> = {
  CONSTITUTIONAL: 'Constitucional (fiebre, peso, fatiga)',
  EYES: 'Ojos',
  ORL: 'ORL (Oídos, Nariz, Garganta)',
  CARDIOVASCULAR: 'Cardiovascular',
  RESPIRATORY: 'Respiratorio',
  GASTROINTESTINAL: 'Gastrointestinal',
  GENITOURINARY: 'Genitourinario',
  MUSCULOSKELETAL: 'Musculoesquelético',
  NEUROLOGICAL: 'Neurológico',
  PSYCHIATRIC: 'Psiquiátrico',
  SKIN: 'Piel',
  ENDOCRINE: 'Endocrino',
  HEMATOLOGIC: 'Hematológico/Linfático',
  ALLERGIC_IMMUNOLOGIC: 'Alérgico/Inmunológico',
};

interface Props {
  systems: ReviewOfSystem[];
  onChange: (systems: ReviewOfSystem[]) => void;
  sectionNumber?: string;
}

export default function ReviewOfSystemsChecklist({ systems, onChange, sectionNumber }: Props) {
  const updateSystem = (code: string, hasFindings: boolean, description: string = '') => {
    const updated = systems.map(s =>
      s.system_code === code ? { ...s, has_findings: hasFindings, findings_description: description } : s
    );
    onChange(updated);
  };

  return (
    <div className="card">
      <div className="card-body">
        <h4 className="card-title">{sectionNumber && <SectionNumberBadge number={sectionNumber} />}<i className="fa fa-list-ul me-2"></i>Revisión por Sistemas</h4>
        <p className="text-muted small mb-3">Marque solo los sistemas con hallazgos positivos</p>

        <div className="row">
          {systems.map(system => (
            <div key={system.system_code} className="col-md-6 mb-3">
              <div className="d-flex align-items-start">
                <div className="flex-grow-1">
                  <strong style={{ fontSize: 13 }}>{SYSTEM_LABELS[system.system_code] || system.system_code}</strong>
                  {system.has_findings && (
                    <textarea
                      className="form-control form-control-sm mt-1"
                      rows={2}
                      value={system.findings_description || ''}
                      onChange={(e) => updateSystem(system.system_code, true, e.target.value)}
                      placeholder="Describa los hallazgos..."
                    />
                  )}
                </div>
                <div className="ms-2 mt-1">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={system.has_findings}
                      onChange={(e) => updateSystem(system.system_code, e.target.checked, system.findings_description || '')}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
